<template>
  <div class="text-center">
    <v-btn class="mb-4 mr-4" text @click="cancel">
      <v-icon left>mdi-arrow-left</v-icon>
      {{ $t("button.back") }}
    </v-btn>
    <v-btn
      :disabled="disabledForm || rejectedForm"
      v-if="updateForm && !(disabledForm || rejectedForm)"
      color="error"
      class="mr-4 mb-4"
      @click="deleteItem"
      >
      <v-icon left>mdi-trash-can-outline</v-icon>
      {{ $t("button.deleteForm") }}
    </v-btn>
    <v-btn
      v-if="!disabledForm"
      color="secondary"
      class="mr-4 mb-4"
      @click="submit('')"
      >
      <v-icon left>mdi-content-save-cog</v-icon>
      {{ $t("button.saveForm") }}
    </v-btn>
    <v-btn
      v-if="pendingAssigment"
      color="orange"
      class="mr-4 mb-4"
      @click="cancelItem"
      >
      <v-icon left>mdi-strategy</v-icon>
      {{ $t("button.retrieveForm") }}
    </v-btn>
    <v-btn
      v-else-if="!disabledForm && !updatedForm"
      :disabled="sendDisabled"
      color="primary"
      class="mr-4 mb-4 white--text"
      @click="submit('send')"
      >
      <v-icon left>mdi-send</v-icon>
      {{ $t("button.sendForm") }}
    </v-btn>
    <v-dialog v-else-if="!disabledForm && updatedForm" v-model="dialog" persistent max-width="470">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          class="mr-4 mb-4"
          dark
          :disabled="sendDisabled"
          v-bind="attrs"
          v-on="on"
        >
          {{ $t("button.sendForm") }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline">
          Se actualizarán los siguientes campos:
        </v-card-title>
        <v-card-text class="text-left"
        ><ul>
          <template v-for="(field,index) in changedFields">
            <li type="disc" v-if="typeof field !== 'object'" :key="index">
              <span> {{$t('form.'+ field)}}</span>
            </li>
            <template v-else v-for="(subField,index2) in field">
              <li type="disc" v-for="(value,index3) in Object.keys(subField)" :key="index+'-'+index2+index3">
                <span>{{$t('form.'+typeChangeFields+'.'+value)}}</span>
              </li>
            </template>
          </template>
        </ul></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false" class="mr-4">
            {{$t('button.back')}}
          </v-btn>
          <v-btn color="primary" text @click="submit('send')">
            {{$t('button.send')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    state: String,
    object_type: String,
    form_name: String,
    form_name_text: String,
    data: Object,
    refForm: Object,
    paginatedForm: Boolean,
    updatedForm:{
      type: Boolean,
      default: false
    },
    changedFields: {
      type: Array,
      default: () => []
    },
    typeChangeFields: {
      type: String,
      default: ''
    },
    saveform_trigger: Boolean,
    sendDisabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false
  }),
  watch: {
    saveform_trigger(){
      this.submit('')
    }
  },
  name: "UserFormActions",
  computed: {
    pendingAssigment() {
      return this.state === "PA";
    },
    createObject() {
      return !(this.$route.params.id > -1) && !this.updateObject;
    },
    updateForm() {
      return this.$route.params.id > -1 && !this.updateObject;
    },
    updateObject() {
      return this.$route.params.id > -1 && this.$route.meta.update;
    },
    rejectedForm() {
      return this.state === "RJ";
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    }
  },
  methods: {
    checkPositionPersons() {
      if (this.object_type === "publication") {
        if (
          this.data.data.user.publication.authorsrel !== undefined &&
          this.data.data.user.publication.authorsrel.length
        ) {
          const positions = this.data.data.user.publication.authorsrel.map(
            function(item) {
              return item.position.toString();
            }
          );
          let findDuplicates = arr =>
            arr.filter((item, index) => arr.indexOf(item) !== index);

          if (findDuplicates(positions).length <= 0) {
            return true;
          } else {
            this.$store.commit("alert", {
              color: "error",
              text: this.$t("form.validation.positions")
            });
            return false;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    checkFiles(send){
      return true;
    },
    submit(send) {
      if (send === "send" && this.sendDisabled) {
        return;
      }
      if (send === "" || this.refForm.validate()) {
        if (this.checkPositionPersons() && this.checkFiles(send)) {
          if (
            this.createObject ||
            this.updateObject ||
            (this.updateForm && this.rejectedForm)
          ) {
            if (this.data.title.replace(/\s/g, "").length) {
              let path = this.$store.state.endpoint + "/user/moderatedOperations";
              let form_trname = `forms.titles.${this.form_name}`
              axios
                .post(path, this.data)
                .then(response => {
                  this.$store.commit("alert", {
                    color: "success",
                    text: this.$t("forms.create", [this.$t(form_trname)])
                  });
                  if (send === "send") {
                    this.sendItem(response.data);
                  } else {
                    if (this.rejectedForm){
                      this.$router.push("/my-forms");
                    }else {
                      this.$router.push(
                              "/my-forms/" +
                              this.object_type +
                              "/" +
                              this.form_name +
                              "/" +
                              response.data.id
                      );
                    }
                  }
                })
                .catch(error => {
                  console.log(error);
                  console.log(error.response.data);
                  this.$store.commit("alert", {
                    color: "error",
                    text: error.response.data
                  });
                });
            } else {
              let form_trname = `error.form.types.${this.object_type}`
              axios
              this.$store.commit("alert", {
                color: "error",
                text: this.$t("error.form.title", [this.$t(form_trname)])
              });
            }
          } else {
            let path =
              this.$store.state.endpoint +
              "/user/moderatedOperations/" +
              this.object_type +
              "/" +
              this.$route.params.id;
            let form_trname = `forms.titles.${this.form_name}`
            axios
              .patch(path, this.data)
              .then(response => {
                this.$store.commit("alert", {
                  color: "success",
                  text: this.$t("forms.update", [this.$t(form_trname)])
                });
                if (send === "send") {
                  this.sendItem(response.data);
                }
              })
              .catch(error => {
                console.log(error);
                console.log(error.response.data);
                this.$store.commit("alert", {
                  color: "error",
                  text: this.$t("error.form.saving", [this.$t(form_trname)])
                });
              });
          }
        }
      } else {
        if (this.paginatedForm) {
          this.$store.commit("alert", {
            color: "error",
            text: this.$t("form.validation.error")
          });
        }
      }
    },

    sendItem(form) {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/send/" +
        this.object_type +
        "/" +
        form.id;
      let form_trname = `forms.titles.${this.form_name}`
      axios
        .patch(path)
        .then(response => {
          form.state = response.data.state;
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("forms.send", [this.$t(form_trname)])
          });
          this.$router.push("/my-forms");
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text:
              "An error occurred while sending the " +
              this.form_name_text +
              " form."
          });
        });
    },

    cancelItem() {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/cancel/" +
        this.object_type +
        "/" +
        this.$route.params.id;
      let form_trname = `forms.titles.${this.form_name}`
      axios
        .patch(path)
        .then(response => {
          this.$emit("change-state", response.data.state);
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("forms.cancel", [this.$t(form_trname)])
          });
          this.$router.push(
            "/my-forms/" +
              this.object_type +
              "/" +
              this.form_name +
              "/" +
              this.$route.params.id
          );
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text:
              "An error occurred while canceling the " +
              this.form_name_text +
              " form"
          });
        });
    },

    deleteItem() {
      if (
        confirm("Are you sure you want to delete this " + this.form_name + "?")
      ) {
        let path =
          this.$store.state.endpoint +
          "/user/moderatedOperations/" +
          this.object_type +
          "/" +
          this.$route.params.id;
        let form_trname = `forms.titles.${this.form_name}`
        axios
          .delete(path)
          .then(response => {
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("forms.delete", [this.$t(form_trname)])
            });
            this.$router.push("/my-forms");
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text:
                "An error occurred while deleting the " +
                this.form_name +
                " form"
            });
          });
      }
    },
    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped></style>
